import { load } from "../../events/load";

const initLogoColor = () => {
  const sidebar = document.querySelector(".site-nav");
  const header = document.querySelector(".header");
  
  if (!sidebar && !header) return;

  let isPastHero = false;

  // Hero для визначення порогу скролу
  const hero = document.querySelector(".hero, .home-hero, [class*='hero']");
  let heroThreshold = hero ? hero.offsetHeight : window.innerHeight;

  // Recalculate threshold on resize to avoid repeated offsetHeight calls
  window.addEventListener('resize', () => {
    heroThreshold = hero ? hero.offsetHeight : window.innerHeight;
  }, { passive: true });

  const updateLogoColor = () => {
    const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;

    if (scrollY > heroThreshold) {
      if (!isPastHero) {
        if (sidebar) sidebar.classList.add("scrolled-past-hero");
        if (header) header.classList.add("scrolled-past-hero");
        isPastHero = true;
      }
    } else {
      if (isPastHero) {
        if (sidebar) sidebar.classList.remove("scrolled-past-hero");
        if (header) header.classList.remove("scrolled-past-hero");
        isPastHero = false;
      }
    }
  };

  let ticking = false;
  window.addEventListener("scroll", () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        updateLogoColor();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  // Ініціалізація
  updateLogoColor();
};

load(initLogoColor);

